import { Routes } from '@angular/router';
import { LayoutPublicComponent } from '@app/layouts/layout-public/layout-public.component';


export const publicRoutes: Routes = [
  {
    path: '',
    component: LayoutPublicComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        title: 'LOGIN.TITLE',
        loadComponent: () =>
          import('./pages/login/login.component').then(m => m.LoginComponent),
      },

    ],
  },
   
];
